// Languages.types.ts

export type SupportedLanguage = "en-us" | "zh-hant" | "zh-hans";

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ["en-us", "zh-hant", "zh-hans"];
